const API = {
  userregister: "userregister",
  verifyuser: "verifyuser",
  login: "login",
  userforgotpassword: "userforgotpassword",
  forgotusercheck: "forgotusercheck",
  usersresetpassword: "usersresetpassword",
  saveuserprofile: "saveuserprofile",
  changepassworduser: "changepassworduser",
  GET_ADMIN_BANK_NAME: "getadminbankdetails",

  CONFIRM_WITHDRAW: "userconfirmwithdraw",

  CURRENCY_LIST: "viewsinglecurrency",


  GET_USER_BANK_DETAILS: "addbankdetails",

  GET_USER_BANK_NAME: "getuserbanklist",

  WITHDRAW_REQUEST: "withdrawrequesttoadmin",

  // Site Settings
  GET_SITE_SETTINGS: "getsitesettings",

  ADD_DEPOSIT_REQUEST: "depositrequesttoadmin",

  //TFA Settings
  ENABLE_TFA: "enableusertfa",
  DISABLE_TFA: "disableusertfa",
  VERIFY_TFA: "verifyuserlogintfa",

  //GET User Details
  GET_USER_DETAILS: "getuserdetails",

  GET_USER_STATISTICS: "getuserstatistics",

  // /user/getcms
  GET_USER_CONTENT: "getcms",

  // user/getfaq
  GET_USER_FAQ: "getfaq",
  // /user/gethomepage
  GET_USER_HOMEPAGE_DETAILS: "gethomepage",
  // user/sendquerytoadmin
  GET_USER_CONTACT_DETAILS: "sendquerytoadmin",
  GET_USER_FAQ: "getfaq",
  // user/userdepositwithdrawhistory
  GET_DEPOSIT_WITHDRAW_HISTORY: "userdepositwithdrawhistory",

  LOGOUT: "logoutuser",

  // KYC
  KYC: "uploaduserkyc",

  // Social Login
  SOCIAL_GOOGLE_LOGIN: "usergooglelogin",
  SOCIAL_FACEBOOK_LOGIN: "userfacebooklogin",
  SOCIAL_APPLE_LOGIN: "userapplelogin",

  // Link Email
  POST_LINK_MAIL: "linkusermail",
  VERIFY_LINK_EMAIL: "verifylinkmail",
  // Game           
  GET_GAME_ROUTE: "getgamebyroutes",
  GET_ALL_MINES: "getallmines",
  GET_SINGLE_MINE: "getsinglemines",

  GET_ACTIVE_GAME_LISTS: "getactivegames",

  GET_ACTIVE_CURRENCY: "getactivecurrency ",
  GET_USER_STATISTICS_GAME: "getuserstatistics",

  GET_OVERALL_STATISTICS: "userstatistics",
  GET_USER_WALLET_BALANCE: "walletuserbalance",


  BET_API: "betmines",
  GET_CURRENT_BET: "getcurrentmines",

  UPDATE_MINE_GAME: "minegameresults",
  // /user/getusergamehistory

  USER_GAME_HISTORY: "getusergamehistory",
  // user/getallusersgame
  GET_GAME_HISTORY: "getallusersgame",

  UPDATE_MINE_GAME_AUTO_MODE: "minegameautoresults",

  GET_RARE_WINNERS: "gethighestwinners",

  GET_BANK_DETAILS_LISTS: "getusersallbanklist",

  UPDATE_BANK_DETAILS: "editbankdata",
  DELETE_BANK_DETAILS: "removebankdata",
  CRASH_BET_API: "betcrash",

  GET_CURRENT_CRASH_BET: "getcurrentcrash",
  GET_ALL_GAME_LISTS: "getallgames",
  GET_MANUAL_CASHOUT_BET: "crashmanualcashout",
  AUTO_CASHOUT_BET: "crashautocashout",
  GET_ALL_GAMES_SEARCH: "searchallgames",
  GET_HIGH_MINE_ROLLERS: "gethighestminesbet",

  GET_HIGH_CRASH_ROLLERS: "gethighestcrashbet",
  GET_ALL_USER_CRASH_HISTORY: "getalluserscrashgame",
  GET_SINGLE_USER_CRASH_HISTORY: "getusercrashhistory",
  GET_SINGLE_GAME_HISTORY: "singlegamehistory",
  LOSS_DATA: "updateresult",
  RARE_WINS: "gethighestcrashwinners",
  CREATE_PAYMENT: "create_payment",
  GET_PAYMENT: "get_payment_tran",
  GET_GAME_STATUS: "gamestatus",
  CHECK_WITHTRAW_MAXIMUM: "check_withdraw_maximum",
  GET_BANNERS: "getbanners",
  RESEND_VERIFY: "resendverifyemail",
  ADD_CPF: "socialuseraddcpf",
};

export default API;